export default "__VITE_ASSET__16e73c65__"